import { useState } from "react";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useAppSettings } from "@/context/SettingsContext";

export const SubscriptionsToggle = () => {
  const { subscriptionsEnabled, updateSettings } = useAppSettings();
  const [saving, setSaving] = useState(false);

  const toggle = async (on) => {
    setSaving(true);
    try {
      await updateSettings({ subscriptions_enabled: on });
      toast.success(on ? "Subscriptions are ON across the site" : "Subscriptions are OFF and hidden everywhere (data is saved)");
    } catch {
      toast.error("Couldn't change subscriptions setting");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="subscriptions-toggle-card"
      className={`flex items-center justify-between gap-3 px-3 py-2.5 rounded-lg border transition-colors ${subscriptionsEnabled ? "border-[#39FF14]/40 bg-[#39FF14]/5" : "border-[#27272A] bg-[#0A0A0A]"}`}>
      <div className="flex items-center gap-2 min-w-0">
        <CreditCard className={`w-4 h-4 shrink-0 ${subscriptionsEnabled ? "text-[#39FF14]" : "text-[#52525B]"}`} />
        <div className="min-w-0">
          <p className="text-white text-sm font-medium leading-tight">Subscriptions</p>
          <p data-testid="subscriptions-toggle-status" className={`text-[11px] leading-tight ${subscriptionsEnabled ? "text-[#39FF14]" : "text-[#71717A]"}`}>
            {subscriptionsEnabled ? "On, shown on site" : "Off, hidden (data saved)"}
          </p>
        </div>
      </div>
      <Switch data-testid="subscriptions-toggle-switch" checked={subscriptionsEnabled} disabled={saving} onCheckedChange={toggle} />
    </div>
  );
};
